module.exports = __webpack_public_path__ + "img/img-7.f7745a20.webp";